import { Injectable, inject } from '@angular/core';
import {LorenBaseCrudService} from '../../../../shared/services/loren-base-crud-service/loren-base-crud.service';
import {LorenAssetProperty} from '../../interfaces/loren-asset-property.interface';
import {LorenAssetPropertyEndpointsService} from '../loren-asset-property-endpoints-service/loren-asset-property-endpoints.service';

@Injectable({
    providedIn: 'root'
})
export class LorenAssetPropertiesService  extends LorenBaseCrudService<LorenAssetProperty> {
    constructor() {
        const endpoints = inject(LorenAssetPropertyEndpointsService);

        super(endpoints.propertyTypes());
    }
}
